/* globals window, document, createjs, define, navigator */

define(["../rmlibrary/util", "./ios_fix", "./dynamic-timeline"], function(util, ios_fix, dynamicTimeline) {
    var ios_fixed = false;
    var isStockAndroid = navigator.userAgent.indexOf("Android 4") >= 0 && navigator.userAgent.indexOf("Version/") >= 0;

    function fontTemplate(f) {
        return "<div style=\"font-family: '" + f + "';\">preload</div>";
    }

    function playerTemplate(width, height, fonts) {
        var frag = document.createDocumentFragment();
        var div = document.createElement("div");
        div.innerHTML =
            '<canvas width="' +
            width +
            '" height="' +
            height +
            '"></canvas><div class="font-preload" aria-hidden="true">' +
            fonts.map(fontTemplate).join("") +
            "</div>";

        while (div.firstChild) { frag.appendChild(div.firstChild); }
        return frag;
    }

    function CanvasPlayer(container, lib, images, options) {
        // var canvas, stage, exportRoot, soundPlayers = [], ended = false, preload, loadingTxt, restartImg;
        var that = this;
        var autoplay = typeof options.autoplay === "undefined" ? true : options.autoplay;
        var preloadImages = typeof options.preloadImages === "undefined" ? true : options.preloadImages;
        this.rootName = options.rootName || "hello";
        this.container = container;
        this.lib = lib;
        this.options = options;
        this._ended = false;

        this.width = this.options.width;
        this.height = this.options.height;
        this._paused = true;
        this._progress = 0;
        this._pixelDensity = this.options.pixelDensity || 1;
        this._audioClips = [];
        this._frameSkipAnchor = {
            time: Date.now(),
            position: 0
        };

        this._filterSoundClip = options.filterSoundClip;

        var preloadFonts = this.options.fonts || [];
        var manifest = lib.properties.manifest;
        if (!preloadImages) {
            manifest = manifest.filter(function(asset) {
                return !/\.(jpg|jpeg|png|gif)$/i.test(asset.src);
            });
        }
        var numFiles = manifest.length;

        this.container.appendChild(playerTemplate(this.options.width, this.options.height, preloadFonts));

        this._canvas = this.container.querySelector("canvas");

        function handleFileLoad(evt) {
            that._progress += 1 / numFiles;
            that.dispatchEvent("progress", false, false);
            if (evt.item.type == "image") {
                images[evt.item.id] = evt.result;
            }
        }

        function handleComplete() {
            that._progress = 1;
            that.dispatchEvent("progress", false, false);
            that.dispatchEvent("canplay", false, false);
            that._canvas.style.display = "block";

            var stage = (that._stage =
                typeof that.lib.Stage === "function"
                    ? new that.lib.Stage(that._canvas)
                    : new createjs.Stage(that._canvas));
            stage.autoClear = true;
            if (options.stageVars) {
                stage.stageVars = options.stageVars;
            }
            that.initExportRoot();

            that.dispatchEvent("durationchange", false, false);

            if (autoplay) { that._paused = false; }
            if (!that._paused) {
                stage.update();
                that._frameSkipAnchor = {
                    time: Date.now(),
                    position: (that._exportRoot.currentFrame * 1000) / that.lib.properties.fps
                };
                that.dispatchEvent("play", false, false);
            } else {
                that._audioClips.forEach(function(clip) {
                    clip.soundInstance.paused = true;
                });
                that.dispatchEvent("pause", false, false);
            }

            createjs.Ticker.setFPS(lib.properties.fps);
            createjs.Ticker.addEventListener("tick", that._tickBound);
        }

        if (manifest.length > 0) {
            var loader = new createjs.LoadQueue(false);
            loader.installPlugin(createjs.Sound);
            loader.setMaxConnections(6);
            loader.addEventListener("fileload", handleFileLoad);
            loader.addEventListener("complete", handleComplete);
            loader.loadManifest(manifest);
        }

        this._togglePausedBound = CanvasPlayer.prototype.togglePaused.bind(this);
        this._handleResizeBound = CanvasPlayer.prototype.handleResize.bind(this);
        this._tickBound = CanvasPlayer.prototype.tickHandler.bind(this);
        this._handleResizeEndDebounced = util.debounce(CanvasPlayer.prototype._handleResizeEnd.bind(this), 50);

        function fullscreenChange() {
            var fullscreenElement =
                document.fullscreenElement ||
                document.mozFullScreenElement ||
                document.webkitFullscreenElement ||
                document.msFullscreenElement;
            var fullscreenEnabled =
                document.fullscreenEnabled ||
                document.mozFullScreenEnabled ||
                document.webkitFullscreenEnabled ||
                document.msFullscreenEnabled;

            if (that._fullscreen && (!fullscreenEnabled || fullscreenElement != that.container)) {
                that._fullscreen = false;
                that.dispatchEvent("fullscreenchange", false, false);
                that.container.classList.remove("fullscreen-on");
            } else if (!that._fullscreen && fullscreenEnabled & (fullscreenElement == that.container)) {
                that._fullscreen = true;
                that.dispatchEvent("fullscreenchange", false, false);
                that.container.classList.add("fullscreen-on");
            }
        }

        document.addEventListener("fullscreenchange", fullscreenChange);
        document.addEventListener("mozfullscreenchange", fullscreenChange);
        document.addEventListener("webkitfullscreenchange", fullscreenChange);
        document.addEventListener("MSFullscreenChange", fullscreenChange);

        window.addEventListener("resize", this._handleResizeBound);

        window.setTimeout(function() {
            that.dispatchEvent("loadstart", false, false);
            if (manifest.length === 0) { handleComplete(); }
        });
    }
    createjs.EventDispatcher.initialize(CanvasPlayer.prototype);

    CanvasPlayer.prototype.updateStageVars = function(newVars) {
        this._stage.stageVars = newVars;
    };

    CanvasPlayer.prototype.grabAudio = function(clip, startFrame) {
        var this$1 = this;

        var movieClipProp, idString, soundInstance;

        for (var key in clip) {
            if (clip.hasOwnProperty(key)) {
                movieClipProp = clip[key];
                if (typeof movieClipProp === "function") {
                    if (movieClipProp.toString().indexOf("playSound") > -1) {
                        idString = movieClipProp.toString().match(/"([^']+)"/)[1];
                        soundInstance = createjs.Sound.createInstance(idString);

                        var audioClip = {
                            startFrame: parseInt(key.toString().split("_")[1]) + startFrame,
                            id: idString,
                            duration: soundInstance.duration,
                            soundInstance: soundInstance
                        };

                        var includeClip = true;
                        if (typeof this$1._filterSoundClip === "function") {
                            includeClip = this$1._filterSoundClip(audioClip);
                        }

                        if (includeClip) {
                            this$1._audioClips.push(audioClip);
                        }
                    }
                }
            }
        }
    };

    CanvasPlayer.prototype.setDynamicScenesCaptions = function() {
        if (typeof this.options.ccName !== "string") { return; }

        var _this = this;
        this._exportRoot._dynamicScenes.forEach(
            function(sceneInfo) {
                Object.keys(sceneInfo.inst)
                    .filter(function(key) {
                        if (key.indexOf(_this.options.ccName) === 0) { return true; }
                    })
                    .forEach(function(key) {
                        sceneInfo.inst[key].visible = _this._ccEnabled;
                    });
            }.bind(this)
        );
    };

    CanvasPlayer.prototype.initExportRoot = function() {
        var exportRoot = (this._exportRoot = new this.lib[this.rootName](createjs.MovieClip.INDEPENDENT, 0, 0));
        if (this.options.dynamicTimeline) {
            dynamicTimeline(exportRoot, this.options.dynamicTimeline);
        }
        this._audioClips = [];
        if (this._exportRoot.childScenes) {
            this._exportRoot.childScenes.forEach(
                function(child) {
                    this.grabAudio(child, child._startFrame);
                }.bind(this)
            );
        } else if (!this._exportRoot._dynamicScenes) {
            this.grabAudio(this._exportRoot, 0);

            if (typeof this.options.ccName === "string" && exportRoot[this.options.ccName]) {
                this._ccInstance = exportRoot[this.options.ccName];
            }
            if (this._ccInstance) {
                this._ccInstance.visible = !!this._ccEnabled;
            }
        } else {
            this._exportRoot._dynamicScenes.forEach(
                function(sceneInfo) {
                    this.grabAudio(sceneInfo.inst, sceneInfo.startFrame);
                }.bind(this)
            );

            this.setDynamicScenesCaptions();
        }

        exportRoot.framerate = this.lib.properties.fps;
        this._stage.addChild(exportRoot);
        this._handleResizeEnd();
    };

    CanvasPlayer.prototype.destroy = function() {
        this.container.removeEventListener("click", this._togglePausedBound);
        window.removeEventListener("resize", this._handleResizeBound);
        createjs.Ticker.removeEventListener("tick", this._tickBound);
        this.container.removeChild(this._canvas);
        this._audioClips.forEach(function(clip) {
            try {
                clip.soundInstance.stop();
            } catch (e) {}
        });
    };

    CanvasPlayer.prototype.tickHandler = function(event) {
        var that = this,
            t,
            delta;
        if (document.hidden) { return; }
        if (that._exportRoot.currentFrame >= that._exportRoot.duration - 1 && !that._ended) {
            that._ended = true;
            that.dispatchEvent("ended", false, false);
            // that._exportRoot.gotoAndStop(that._exportRoot.duration - 1);

            that._audioClips.forEach(function(clip) {
                clip.soundInstance.stop();
            });
        }
        that._stage.tickOnUpdate = !this._paused;

        t = (that._exportRoot.currentFrame * 1000) / that.lib.properties.fps;
        if (that.options.useInternalSkipper) {
            delta = Math.max(0, Date.now() - (that._frameSkipAnchor.time - that._frameSkipAnchor.position) - t);
        } else {
            delta = typeof this.options.timeError === "function" ? this.options.timeError.call(this, t) || 0 : 0;
        }
        if (delta) {
            event.delta += delta;
        }
        t = Math.round(t + delta / 50) / 20;
        // if (t > that._exportRoot.duration * 1000 / that.lib.properties.fps) {
        //     t = that._exportRoot.duration * 1000 / that.lib.properties.fps;
        // }
        if (t !== that._lastReportedTime) {
            that._lastReportedTime = t;
            that.dispatchEvent("timeupdate", false, false);
        }
        if (!createjs.Ticker.getPaused() && !that._paused) {
            that._loopThroughAudio(that._exportRoot.currentFrame);
            that._stage.update(event);
        }
    };

    CanvasPlayer.prototype._loopThroughAudio = function(frameNum, seeking) {
        var frameDuration,
            that = this,
            fps = that.lib.properties.fps;

        that._audioClips.forEach(function(clip) {
            frameDuration = clip.duration / fps;

            if (seeking) {
                clip.played = false;
            }

            if (frameNum >= clip.startFrame && frameNum < clip.startFrame + frameDuration) {
                if (!clip.played) {
                    clip.played = true;
                    clip.soundInstance.position = ((frameNum - clip.startFrame) * 1000) / fps;

                    if (!that._paused) {
                        clip.soundInstance.play();
                    }
                } else if (seeking) {
                    clip.soundInstance.position = ((frameNum - clip.startFrame) * 1000) / fps;
                }
            } else if (typeof clip.soundInstance !== "undefined") {
                clip.soundInstance.stop();
            }
        });

        return true;
    };

    CanvasPlayer.prototype.togglePaused = function() {
        if (this._ended) {
            this._ended = false;
            this._paused = false;
            // this._exportRoot.gotoAndPlay(0);
            this._audioClips.forEach(function(clip) {
                clip.played = false;
            });
            try {
                this._stage.removeChild(this._exportRoot);
            } catch (e) {}
            this.initExportRoot();
            this.dispatchEvent("play", false, false);
        } else {
            var paused = (this._paused = !this._paused);

            this._audioClips.forEach(function(clip) {
                clip.played = false;
                clip.soundInstance.paused = paused;
            });

            if (this._paused) {
                this.dispatchEvent("pause", false, false);
            } else {
                this._frameSkipAnchor = {
                    time: Date.now(),
                    position: (this._exportRoot.currentFrame * 1000) / this.lib.properties.fps
                };
                this.dispatchEvent("play", false, false);
            }
        }
    };

    CanvasPlayer.prototype.goToFrame = function(frameNum) {
        var that = this,
            movieClipFrame;

        that._exportRoot.gotoAndPlay(frameNum);
        that._frameSkipAnchor = {
            time: Date.now(),
            position: (frameNum * 1000) / that.lib.properties.fps
        };

        if (that._exportRoot._dynamicScenes) {
            that._exportRoot._dynamicScenes.forEach(function(e) {
                if (!e.background && frameNum >= e.startFrame && frameNum < e.startFrame + e.duration) {
                    movieClipFrame = frameNum - e.startFrame;
                    e.inst.gotoAndPlay(movieClipFrame);
                }
            });
        }

        if (isStockAndroid) {
            that._stage.clear();
            createjs.Ticker.paused = true;
            window.setTimeout(function() {
                that._stage.update();
                createjs.Ticker.paused = false;
            }, 1000);
        } else {
            if (that._paused) { that._stage.update(); }
        }
        that._loopThroughAudio(frameNum, true);
    };

    CanvasPlayer.prototype.restart = function() {
        this._ended = false;
        this._paused = false;
        this._audioClips.forEach(function(clip) {
            clip.soundInstance.stop();
        });
        try {
            this._stage.removeChild(this._exportRoot);
        } catch (e) {}
        this.initExportRoot();
        this.dispatchEvent("play", false, false);
    };

    CanvasPlayer.prototype.handleResize = function() {
        createjs.Ticker.paused = true;
        this._handleResizeEndDebounced();
    };

    CanvasPlayer.prototype._handleResizeEnd = function(force) {
        var that = this;
        if (!force && createjs.BrowserDetect.isIOS) {
            window.setTimeout(function() {
                that._handleResizeEnd(true);
            }, 350);
            return;
        }

        var cw = this.container.offsetWidth,
            ch = this.container.offsetHeight,
            factorW = cw / this.width,
            factorH = ch / this.height,
            factor = Math.min(factorW, factorH),
            vw = factor * this.width,
            vh = factor * this.height,
            pixelDensity = this._pixelDensity || 1;

        //vh = $(window).height() - $('.header-utility').height() - $('.depth1').height();
        this._canvas.width = vw * pixelDensity;
        this._canvas.height = vh * pixelDensity;
        this._canvas.style.width = vw + "px";
        this._canvas.style.height = vh + "px";
        this._canvas.style.left = Math.round((cw - vw) / 2) + "px";
        this._canvas.style.top = Math.round((ch - vh) / 2) + "px";

        if (this.options.resizeEndHook) { this.options.resizeEndHook.call(this); }

        this._exportRoot.setTransform(0, 0, factor * pixelDensity, factor * pixelDensity);

        if (isStockAndroid) {
            this._stage.clear();
            window.setTimeout(function() {
                if (that._paused) { that._stage.update(); }
                createjs.Ticker.paused = false;
                that.dispatchEvent("resizeEnd", false, false);
            }, 350);
        } else {
            createjs.Ticker.paused = false;
            if (this._paused) { this._stage.update(); }
            this.dispatchEvent("resizeEnd", false, false);
        }
    };

    CanvasPlayer.prototype.getDuration = function() {
        return Math.round(this._exportRoot.duration / this.lib.properties.fps);
    };

    CanvasPlayer.prototype.getTotalFrames = function() {
        return this._exportRoot.duration;
    };

    CanvasPlayer.prototype.getCurrentTime = function() {
        return Math.round((20 * this._exportRoot.currentFrame) / this.lib.properties.fps) / 20;
    };

    CanvasPlayer.prototype.toggleFullscreen = function() {
        var fullscreenEnabled =
            document.fullscreenEnabled ||
            document.mozFullScreenEnabled ||
            document.webkitFullscreenEnabled ||
            document.msFullscreenEnabled;
        var el = this.container;

        if (fullscreenEnabled) {
            createjs.Ticker.paused = true;
            this._handleResizeEndDebounced();
            if (!this._fullscreen) {
                if (el.requestFullscreen) {
                    el.requestFullscreen();
                } else if (el.mozRequestFullScreen) {
                    el.mozRequestFullScreen();
                } else if (el.webkitRequestFullscreen) {
                    el.webkitRequestFullscreen();
                } else if (el.msRequestFullscreen) {
                    el.msRequestFullscreen();
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
            }
        }
    };

    CanvasPlayer.prototype.getAudioById = function(id) {
        var this$1 = this;

        for (var i = 0; i < this._audioClips.length; i++) {
            var clip = this$1._audioClips[i];
            if (clip.id === id) {
                return clip;
            }
        }
    };

    CanvasPlayer.prototype.isFullscreen = function() {
        return this._fullscreen;
    };

    CanvasPlayer.prototype.toggleCC = function() {
        this._ccEnabled = !this._ccEnabled;
        if (!this._exportRoot._dynamicScenes && this._ccInstance) {
            this._ccInstance.visible = !!this._ccEnabled;
        } else {
            this.setDynamicScenesCaptions();
        }
    };

    CanvasPlayer.prototype.isCC = function() {
        return this._ccEnabled;
    };

    CanvasPlayer.prototype.getProgress = function() {
        return this._progress;
    };

    CanvasPlayer.canAutoPlay = function() {
        //return !createjs.BrowserDetect.isIOS || ios_fixed;
        if (!createjs.BrowserDetect.isIOS && !createjs.BrowserDetect.isAndroid) {
            return true;
        }
        if (createjs.BrowserDetect.isIOS && ios_fixed) {
            return true;
        }
        return false;
    };

    if (createjs.BrowserDetect.isIOS) {
        ios_fix.init();
        document.body.addEventListener(
            "touchstart",
            function() {
                ios_fix.handler();
                ios_fixed = true;
            },
            false
        );
        document.body.addEventListener(
            "touchend",
            function() {
                ios_fix.handler();
                ios_fixed = true;
            },
            false
        );
    }

    CanvasPlayer.prototype.reflow = function(sceneList, scene) {
        //this._stage.removeChild(this._exportRoot);
        this.options.dynamicTimeline = sceneList;
        dynamicTimeline(this._exportRoot, sceneList);
        this._audioClips = [];
        if (!this._exportRoot._dynamicScenes) {
            this.grabAudio(this._exportRoot, 0);
        } else {
            this._exportRoot._dynamicScenes.forEach(
                function(sceneInfo) {
                    this.grabAudio(sceneInfo.inst, sceneInfo.startFrame);
                }.bind(this)
            );
        }
        //this.restart();
        if (scene) { this.goToScene(scene); }
    };

    CanvasPlayer.prototype.goToScene = function(scene) {
        if (typeof scene === "object") { scene = scene.id; }
        scene = this._exportRoot._dynamicScenes.filter(function(e) {
            return e.id === scene;
        })[0];
        if (!scene) { return; }
        this.goToFrame(scene.startFrame);
    };

    return CanvasPlayer;
});
